// extracted by mini-css-extract-plugin
module.exports = {"prompt":"_dbef2128","button":"_537b84fa"};